<template>
  <div>
    <v-card class="pa-3 rounded_max" elevation="1">
      <v-row no-gutters>
        <v-col cols="12" md="7" lg="7" sm="12">
          <div class="pa-3">
            <p class="default_txt">Question</p>
            <v-text-field
              v-if="readonly"
              readonly
              dense
              v-model="question.question"
              placeholder="Type Here"
              hide-details="auto"
              :error-messages="err.question.txt"
              :color="color"
            ></v-text-field>
            <v-text-field
              v-else
              dense
              v-model="question.question"
              placeholder="Type Here"
              hide-details="auto"
              :error-messages="err.question.txt"
              :color="color"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" md="5" lg="5" sm="12">
          <div class="pa-3">
            <p class="default_txt">Question type </p>
            <v-select
              v-if="readonly"
              readonly
              dense
              hide-details="auto"
              :items="listType"
              v-model="question.type"
              placeholder="Click Here"
              flat
              :color="color"
            ></v-select>
            <v-select
              v-else
              dense
              hide-details="auto"
              :items="listType"
              v-model="question.type"
              placeholder="Click Here"
              flat
              :color="color"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <div class="mt-3" v-if="question.type == 'multiple'">
        <v-row no-gutters v-for="(opt, i) in question.option" :key="`opt-${i}`">
          <v-col cols="1" md="1">
            <div class="d-flex align-end pa-2" style="height: 100%">
              <v-icon>mdi-radiobox-blank</v-icon>
            </div>
          </v-col>
          <v-col cols="6" md="6">
            <div class="pa-2">
              <div class="d-flex align-end">
                <b class="mr-2 mb-n1">{{ opt.key.toUpperCase() }}.</b>
                <v-text-field
                  dense
                  v-if="readonly"
                  readonly
                  v-model="opt.val"
                  placeholder="Type Here"
                  :ref="`opt-${opt.key}`"
                  hide-details
                  :color="color"
                  @focus="firstSelect(opt, i)"
                  @keyup.enter="addOpt(question.option)"
                ></v-text-field>
                <v-text-field
                  dense
                  v-else
                  v-model="opt.val"
                  placeholder="Type Here"
                  :ref="`opt-${opt.key}`"
                  hide-details
                  :color="color"
                  @focus="firstSelect(opt, i)"
                  @keyup.enter="addOpt(question.option)"
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="2">
            <div
              class="d-flex align-end pa-2"
              style="height: 100%"
              v-if="question.option.length > 1"
            >
              <v-btn
                small
                icon
                v-if="!readonly"
                class="pa-0"
                @click="delOpt(opt)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="1" md="1">
            <div class="d-flex align-end pa-2" style="height: 100%">
              <v-icon>mdi-radiobox-blank</v-icon>
            </div>
          </v-col>
          <v-col cols="6" md="6">
            <div class="pa-2">
              <v-btn
                v-if="!readonly"
                class="text-capitalize py-1 px-0"
                text
                height="max-content"
                max-width="max-content"
                @click="addOpt(question.option)"
                >Add option</v-btn
              >
            </div>
          </v-col>
        </v-row>
        <div class="px-3">
          <p class="small_txt red--text ma-0 mt-1">
            {{ err.opt.txt }}
          </p>
        </div>
        <div style="height: 20px"></div>
      </div>
      <div>
        <v-row no-gutters>
          <v-col cols="12" md="7" lg="7" sm="12">
            <div class="pa-3">
              <p class="default_txt">Answer</p>
              <v-text-field
                v-if="readonly"
                readonly
                dense
                v-model="question.answer"
                placeholder="Type Here"
                :error-messages="err.answer.txt"
                hide-details="auto"
                :color="color"
              ></v-text-field>
              <v-text-field
                v-else
                dense
                v-model="question.answer"
                placeholder="Type Here"
                :error-messages="err.answer.txt"
                hide-details="auto"
                :color="color"
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <div class="d-flex justify-end mt-4">
      <v-btn
        v-if="!loading && !readonly"
        :class="` text-capitalize rounded-lg`"
        depressed
        dark
        :color="color"
        @click="validateCreate"
        >Add Question</v-btn
      >
      <v-btn
        v-if="loading"
        :class="` text-capitalize rounded-lg`"
        depressed
        dark
        :color="color"
        >Loading...</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "quizModule",
  data() {
    return {
      loading: false,
      listType: ["multiple", "essay"],
      getAway: false,
      err: {
        question: {
          txt: "",
          status: 0,
        },
        opt: {
          txt: "",
          status: 0,
        },
        answer: {
          txt: "",
          status: 0,
        },
      },
      question: {
        type: "multiple",
        question: "",
        option: [
          {
            key: "a",
            val: "Option",
          },
        ],
        answer: "",
      },
    };
  },
  props: ["color", "module", "readonly"],
  methods: {
    validateCreate() {
      let vm = this;
      if (vm.question.question == "") {
        vm.err.question.txt = "Question cannot be empty";
        vm.err.question.status = 1;
      } else {
        vm.err.question.txt = "";
        vm.err.question.status = 0;
      }
      if (vm.question.answer == "") {
        vm.err.answer.txt = "Answer cannot be empty";
        vm.err.answer.status = 1;
      } else {
        vm.err.answer.txt = "";
        vm.err.answer.status = 0;
      }
      if (vm.question.type == "multiple") {
        if (vm.question.option.length <= 1) {
          vm.err.opt.txt = "choice must be more than 1";
          vm.err.opt.status = 1;
        } else {
          let isThere = vm.question.option.find((el) => {
            return el.key == vm.question.answer.toLowerCase();
          });
          if (isThere) {
            vm.err.opt.txt = "";
            vm.err.opt.status = 0;
          } else {
            vm.err.opt.status = 1;
            vm.err.answer.txt =
              "The answer was not found in the list of options";
          }
        }
      }
      let count = 0;
      for (let i in vm.err) {
        count = count + vm.err[i].status;
      }
      if (count == 0) {
        this.createQuestion();
      }
    },
    createQuestion() {
      this.loading = true;
      let dataQuiz = null;
      let choice = "";
      let vm = this;
      if (vm.question.type == "multiple") {
        vm.question.option.forEach((el, i) => {
          choice =
            choice +
            `${el.key}:${el.val}${
              i !== vm.question.option.length - 1 ? ";" : ""
            }`;
        });
        dataQuiz = {
          type: vm.question.type,
          question: vm.question.question,
          choice: choice,
          answer: vm.question.answer.toLowerCase(),
        };
      } else {
        dataQuiz = {
          type: vm.question.type,
          question: vm.question.question,
          answer: vm.question.answer,
        };
      }
      let body = {
        course_quiz_id: this.module.id,
        data_quiz: JSON.stringify([dataQuiz]),
      };
      let data = {
        path: `manage/quiz/create`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.question = {
            type: "multiple",
            question: "",
            option: [
              {
                key: "a",
                val: "Option",
              },
            ],
            answer: "",
          };
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.loading = false;
          this.$emit("fetch");
        })
        .catch((err) => {
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    addOpt(list) {
      this.err.opt.txt = "";
      let char = list[list.length - 1].key;
      let next = String.fromCharCode(char.charCodeAt(0) + 1);
      this.question.option.push({
        key: next,
        val: `New Option`,
      });
      setTimeout(() => {
        this.$refs[`opt-${next}`][0].$refs.input.focus();
        this.$refs[`opt-${next}`][0].$refs.input.select();
      }, 100);
    },
    firstSelect(item) {
      this.$refs[`opt-${item.key}`][0].$refs.input.select();
    },
    delOpt(item) {
      const index = this.question.option.indexOf(item);
      if (index > -1) {
        this.question.option.splice(index, 1);
        this.question.option.forEach((item, i) => {
          item.key = (i + 10).toString(36);
        });
      }
    },
  },
};
</script>

<style></style>
